var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkforce(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34334 6.34085C5.285 6.33502 5.215 6.33502 5.15084 6.34085C3.7625 6.29419 2.66 5.15669 2.66 3.75669C2.66 2.32752 3.815 1.16669 5.25 1.16669C6.67917 1.16669 7.84 2.32752 7.84 3.75669C7.83417 5.15669 6.73167 6.29419 5.34334 6.34085Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57251 2.33331C10.7042 2.33331 11.6142 3.24915 11.6142 4.37498C11.6142 5.47748 10.7392 6.37581 9.64834 6.41665C9.60167 6.41081 9.54917 6.41081 9.49667 6.41665",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42667 8.49337C1.015 9.43837 1.015 10.9784 2.42667 11.9175C4.03084 12.9909 6.66167 12.9909 8.26584 11.9175C9.6775 10.9725 9.6775 9.43254 8.26584 8.49337C6.6675 7.42587 4.03667 7.42587 2.42667 8.49337Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6983 11.6666C11.1183 11.5791 11.515 11.41 11.8417 11.1591C12.7517 10.4766 12.7517 9.35079 11.8417 8.66829C11.5208 8.42329 11.13 8.25996 10.7158 8.16663",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforce);
export default __webpack_public_path__ + "static/media/Workforce.4f836e86e9ac8113a5c9b0a63b2d60b4.svg";
export { ForwardRef as ReactComponent };